import { render, staticRenderFns } from "./add-update-resource.vue?vue&type=template&id=c0072f92&scoped=true"
import script from "./add-update-resource.vue?vue&type=script&lang=js"
export * from "./add-update-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0072f92",
  null
  
)

export default component.exports